import React, { useState } from 'react';

import { FilterButton, FilterChips, FilterWrapper } from 'components/FilterComponentsV2';

import { useMobileViewport } from 'hooks/useMobileViewport';
import { usePicklistDetailsSelector } from 'hooks/Picklist';

import Filter from './Filter';

import { generateChips, removeChip } from '../../../helpers';

export function PicklistFilter({ onApply, chips, setChips }) {
  const isMobile = useMobileViewport();

  const [open, setOpen] = useState(false);

  const { criteria, filter } = usePicklistDetailsSelector();

  const openFilter = () => setOpen(true);

  const applyFilter = (filters) => {
    setChips(generateChips(criteria, filters));
    onApply(filters);
  };

  const deleteChip = (chip) => applyFilter(removeChip(criteria, filter.filters, chip));

  return (
    <FilterWrapper>
      <FilterButton onClick={openFilter} isActive={open || !!chips?.length} />
      {!isMobile && <FilterChips chips={chips} onDelete={deleteChip} />}

      {open && <Filter open={open} setOpen={setOpen} filter={filter} onApply={applyFilter} />}
    </FilterWrapper>
  );
}
